import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { ActivatedRouteSnapshot } from '@angular/router';
import { PartnerService } from '../services/partner.service';
import { QueryParams } from '@interfaces/query-params.interface';
import { ORDER } from '@enums/enum';

@Injectable()
export class PartnersResolver implements Resolve<any> {
    constructor(private partnerService: PartnerService) { }
    public resolve(route: ActivatedRouteSnapshot) {
        const params: QueryParams = {
            size: 1000,
            page: 0,
            order: ORDER.ASC,
            sort: 'createdAt'
        }
        return this.partnerService.findAllPageableResponse(params);
    }
}
